export const KEYBOARD_KEYS = {
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  0: "0",
  DOT: ".",
  COMMA: ",",
  SPACE: " ",
  BACKSPACE: "Backspace",
  DELETE: "Delete",
} as const;

export const SPACE = KEYBOARD_KEYS.SPACE;
export const DECIMAL_PART_SIZE = 2;
export const DECIMAL_SEPARATOR = KEYBOARD_KEYS.COMMA;
export const EMPTY_INTEGER_PART = "0";
export const EMPTY_DECIMAL_PART = "00";
export const THOUSAND_GROUP_SIZE = 3;

export const MAX_INTEGER_NUMBER_LENGTH = 4 * THOUSAND_GROUP_SIZE;

export const VALID_KEYS = new RegExp(
  `\\d|\\,|\\.|(${KEYBOARD_KEYS.BACKSPACE})|(${KEYBOARD_KEYS.DELETE})`
);
